import React, { Component } from 'react'
import { connect } from 'react-redux'

import { GetCarRentalLog } from '../../../actions/shops'
import { renderFullDate } from '../../../utils/time'
import { translation } from '../../../utils/helpers'

// Elements
import Panel from '../../../shared/elements/panel'
// import TableRow from '../../../shared/elements/tableRow'
// import TableContainer from '../../../shared/elements/tableContainer'
// import PanelHeader from '../../../shared/elements/panelHeader'
import Grid from '../../../shared/elements/grid'
import LabelWrapper from '../../../shared/elements/labelWrapper'

// Styles
import './carRentalLog.scss'

class CarRentalLog extends Component {
  constructor (props) {
    super(props)

    this.state = {
      carId: 0,
      logs: []
    }

    this.renderLog = this.renderLog.bind(this)
    this.getCarRentalLog = this.getCarRentalLog.bind(this)
  }

  componentDidMount () {
    this.getCarRentalLog(this.props.rentalCarId)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.rentalCarId !== this.props.rentalCarId) {
      this.getCarRentalLog(nextProps.rentalCarId)
    }
  }

  // shouldComponentUpdate (nextProps) {
  //   //if (nextProps.rentalCarId !== this.state.carId) {
  //   if (nextProps.rentalCarId !== this.props.rentalCarId) {
  //     this.getCarRentalLog(nextProps.rentalCarId)
  //     return true
  //   } else {
  //     return false
  //   }
  // }

  getCarRentalLog (rentalCarId) {
    this.props.GetCarRentalLog(rentalCarId).then(res => {
      this.setState({
        logs: res.data,
        carId: rentalCarId
      })
    })
  }

  renderLog (logLine, key) {
    let info = logLine.OrderID > 0 ? logLine.OrderID : logLine.Note
    const goTo = (info, e) => {
      e.preventDefault()
      if (!isNaN(info)) {
        this.props.router.replace({
          pathname: '/orders/' + info
        })
      }
    }
    // onClick={goTo.bind(this, logLine.OrderID)}
    return (
      <Grid key={key} cols={['max-content', 1]} spacing={1}>
        <span>{renderFullDate(logLine.StartDate, false) + ' - ' + renderFullDate(logLine.EndDate, false)}</span>
        {logLine.OrderID > 0 ? <a onClick={goTo.bind(this, logLine.OrderID)} href=''>{info}</a> : <span>{info}</span>}
      </Grid>
    )
  }

  render () {
    return (
      <Panel title={translation('2211')}>
        <Grid cols={[1.75, 1.25]}>
          <LabelWrapper labelText={translation('434')} />
          <LabelWrapper labelText={translation('13420')} />
        </Grid>
        {this.state.logs.length > 0 && this.state.logs.map(this.renderLog)}
      </Panel>
    )
  }
}

function mapStateToProps (state) {
  return {

  }
}

export default connect(mapStateToProps, {
  GetCarRentalLog
})(CarRentalLog)



// WEBPACK FOOTER //
// ./src/app/pages/CarRental/CarRentalLog/index.js